import { CaseStatus } from './case.js';
import { NotificationTemplate } from './notificationTemplate.js';
import { NotificationType } from './notification.js';

// This is a synthetic type that should eventually be modelled in the database.

export const WORKFLOW_STAGE_NOTIFICATION_TYPES: { [key in CaseStatus]?: NotificationType | null } =
  {
    [CaseStatus.InProgress]: null,
    [CaseStatus.Incomplete]: NotificationType.ApplicationIncomplete,
    [CaseStatus.ReadyForReview]: null,
    [CaseStatus.InReview]: null,
    [CaseStatus.Approved]: NotificationType.ApplicationApproved,
    [CaseStatus.Denied]: NotificationType.ApplicationDenied,
    [CaseStatus.PaymentSent]: NotificationType.PaymentsFundsIssued,
  };

export interface WorkflowNotification {
  template: NotificationTemplate;
}

export interface WorkflowStage {
  status: CaseStatus;
  order?: number;
  description?: string;
  workflowNotifications: WorkflowNotification[];
}
